import { BaseContainerModel } from '../../base-container.model';
import {bl_fi_mto_section_hdr_RowClass} from '../../../dbschema';

export class MTOSectionHdrContainerModel extends BaseContainerModel {

  bl_fi_mto_section_hdr: bl_fi_mto_section_hdr_RowClass = new bl_fi_mto_section_hdr_RowClass();
}
